import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import { Link, Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  ShoppingBagIcon,
  MenuAlt2Icon,
  UsersIcon,
  ArchiveIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  XCircleIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import { Oval } from "react-loader-spinner";
import {ToastContainer, toast } from 'react-toastify';

const navigation = [
  { name: "Customer", href: "Customerlist", icon: UsersIcon, current: true },

  { name: "Vendor", href: "Vendorslist", icon: ArchiveIcon, current: false },
  { name: "Employee", href: "Employeelist", icon: UsersIcon, current: false },
  { name: "Item", href: "Itemlist", icon: ShoppingBagIcon, current: false },
  {
    name: "Invoice",
    href: "Invoicelist",
    icon: ShoppingCartIcon,
    current: false,
  },
  {
    name: "Purchase Order",
    href: "Purchaseorderlist",
    icon: ShoppingBagIcon,
    current: false,
  },
  { name: "Lead", href: "LeadList", icon: ClipboardIcon, current: false },
  {
    name: "Branch",
    href: "branchranch",
    icon: ShoppingBagIcon,
    current: false,
  },
  { name: "Warehouse", href: "WarehouseList", icon: HomeIcon, current: false },
  { name: "Bills", href: "Billslist", icon: DocumentIcon, current: false },
  {
    name: "Expense",
    href: "ExpenseList",
    icon: ColorSwatchIcon,
    current: false,
  },
  {
    name: "Inventory Transfer",
    href: "InventorytranferList",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "Inventory Adjustments",
    href: "InventoryadjustmentsList",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "FIFO Lot Tracking",
    href: "/crm/Fiforeport",
    icon: ShoppingBagIcon,
    current: false,
  },
  {
    name: "Setting",
    current: false,
    icon: CogIcon,
    children: [
      { name: "Lead Source", href: "LeadsourceList" },
      { name: "Lead Status", href: "LeadstatusList" },
      { name: "Brand", href: "BrandList" },
      { name: "Manufacturer", href: "ManufacturersList" },
      { name: "Mode of Payment", href: "ModeofpaymentList" },
      { name: "Expense Category", href: "ExpensecateList" },
      { name: "Reason", href: "Reasonlist" },
    ],
  },
];
const userNavigation = [{ name: "Logout", href: "Login" }];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Test1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      customer_type_id: "",
      primary_contact_salutation_id: "",
      primary_contact_first_name: "",
      primary_contact_last_name: "",
      company_name: "",
      customer_display_name: "",
      customer_email: "",
      customer_work_phone: "",
      customer_mobile: "",
      designation: "",
      department: "",
      website: "",
      tax_preference_id: null,
      currency_id: null,
      payment_term_id: null,
      gstin_uin: null,
      billing_attention: null,
      billing_country_region: null,
      billing_address_street_one: null,
      billing_address_street_two: null,
      billing_city: null,
      billing_state: null,
      billing_zip_code: null,
      billing_phone: null,
      shipping_attention: null,
      shipping_country_region: null,
      shipping_address_street_one: null,
      shipping_address_street_two: null,
      shipping_city: null,
      shipping_state: null,
      shipping_zip_code: null,
      shipping_phone: null,
      place_of_supply_id: null,
      success: false,
      redirect: false,
      contactperson: [],
      error_list: [],
      salutationsList: [],
      cutomerTypelist: [],
      taxprefercenceList: [],
      currencyList: [],
      paymentTerm: [],
      countriesList: [],
      placeofSupply: [],
      shippingstatelist: [],
      billingstatelist: [],
      loader: "",
      overLay: "fixed inset-0 bg-black/50 ",
      toastID:"1",
    };
    this.handleInput = this.handleInput.bind(this);
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  checkInternetCon() {
    window.addEventListener("offline", (e) => {
      console.log("offline");
    });
    window.addEventListener("online", (e) => {
      console.log("online");
    });
  }

  componentDidMount() {
   
    this.setLoaderFunction();
   
    const token = localStorage.getItem("token");

    function getsalutations() {
      return axios.get('/public/api/salutations');
    }
    
    function gettaxpreferences() {
      return axios.get('/public/api/taxpreferences');
    }
    function getcurrencies() {
      return axios.get('/public/api/currencies');
    }
    function getpaymentterms() {
      return axios.get('/public/api/paymentterms');
    }
    function getcustomertypes() {
      return axios.get('/public/api/customertypes');
    }
    function getcountries() {
      return axios.get('/public/api/countries');
    }
    function getplaceofsupply() {
      return axios.get('/public/api/customer/place/of/supply');
    }
    
  
  
   const p1= Promise.all([getsalutations(), gettaxpreferences(),getcurrencies(),getpaymentterms(),getcustomertypes(),getcountries(),getplaceofsupply()])
      .then(axios.spread((salutationsList, taxprefercenceList, currencyList, paymentTerm,cutomerTypelist,countriesList,placeofSupply) => {
        this.setState({ salutationsList: salutationsList.data.salutations });
        this.setState({ taxprefercenceList: taxprefercenceList.data.taxpreferences });
        this.setState({ currencyList: currencyList.data.currencies });
        this.setState({ paymentTerm: paymentTerm.data.paymentterms });
        this.setState({ cutomerTypelist: cutomerTypelist.data.customertypes });
        this.setState({ countriesList: countriesList.data.countries });
        this.setState({ placeofSupply: placeofSupply.data.place_of_supply });
       
      }));
      const toastId = 1;
    toast.promise(
        p1,
        {
          pending: 'Loading',
          success: 'Resolved ',
          error: 'Network problem',
          toastId:toastId,
        }
    )
       

    this.closeLoaderFuncion();
  }

  handleInput = (e) => {
    const token = localStorage.getItem("token");

    if (e.target.name == "billing_country_region") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          
          setTimeout(
            function () {
              this.closeLoaderFuncion();
            }.bind(this),
            500
          );
          this.setState({ billingstatelist: res.data.states });
        });
        toast.promise(
          res,
         {
           pending: 'Loading',
           success: "Done",
           error: 'Try Again',
           toastId:this.state.toastID
         });
    } else {
      //console.log("else");
    }

    if (e.target.name === "shipping_country_region") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          setTimeout(
            function () {
              this.closeLoaderFuncion();
            }.bind(this),
            500
          );
          this.setState({ shippingstatelist: res.data.states });
          toast.promise(
            res,
           {
             pending: 'Loading',
             success: "Done",
             error: 'Try Again',
             toastId:this.state.toastID
           });
        });
    } else {
      console.log("");
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  saveCustomer = async (e) => {
    e.preventDefault();
    let contacp1 = [];
    contacp1["contact_person_salutation_id"] = "1";
    contacp1["contact_person_first_name"] = "v 4";
    contacp1["contact_person_last_name"] = "v 4";
    contacp1["contact_person_email_address"] = "ram@dreamstech.co";
    contacp1["contact_person_mobile"] = "998989";
    this.state.contactperson.push(Object.assign({}, contacp1));

    //var cars = [];
    //cars['contact_person_salutation_id']=8;
    //this.state.contactperson.push( Object.assign({}, cars))

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("public/api/customer/create", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1500
      );
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function

  render() {
    
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/Customerlist"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}

        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          <Transition.Root show={this.state.sidebarOpen} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 flex z-40 md:hidden"
              onClose={this.close}
            >
              <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
              </Transition.Child>
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => this.close}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex-shrink-0 flex items-center px-4">
                    <img className="h-8 w-auto" src={mainLogo} alt="Workflow" />
                  </div>
                  <div className="mt-5 flex-1 h-0 overflow-y-auto">
                    <nav
                      className="flex-1 px-2 space-y-1 bg-white"
                      aria-label="Sidebar"
                    >
                      {navigation.map((item) =>
                        !item.children ? (
                          <div key={item.name}>
                            <a
                              href={item.href}
                              className={classNames(
                                item.current
                                  ? "bg-gray-100 text-gray-900"
                                  : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md"
                              )}
                            >
                              <item.icon
                                className={classNames(
                                  item.current
                                    ? "text-gray-500"
                                    : "text-gray-400 group-hover:text-gray-500",
                                  "mr-3 flex-shrink-0 h-6 w-6"
                                )}
                                aria-hidden="true"
                              />
                              {item.name}
                            </a>
                          </div>
                        ) : (
                          <Disclosure
                            as="div"
                            key={item.name}
                            className="space-y-1"
                          >
                            {({ open }) => (
                              <>
                                <Disclosure.Button
                                  className={classNames(
                                    item.current
                                      ? "bg-gray-100 text-gray-900"
                                      : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                    "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                  )}
                                >
                                  <item.icon
                                    className="mr-3 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                    aria-hidden="true"
                                  />
                                  <span className="flex-1">{item.name}</span>
                                  <svg
                                    className={classNames(
                                      open
                                        ? "text-gray-400 rotate-90"
                                        : "text-gray-300",
                                      "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
                                    )}
                                    viewBox="0 0 20 20"
                                    aria-hidden="true"
                                  >
                                    <path
                                      d="M6 6L14 10L6 14V6Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </Disclosure.Button>
                                <Disclosure.Panel className="space-y-1">
                                  {item.children.map((subItem) => (
                                    <Disclosure.Button
                                      key={subItem.name}
                                      as="a"
                                      href={subItem.href}
                                      className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                                    >
                                      {subItem.name}
                                    </Disclosure.Button>
                                  ))}
                                </Disclosure.Panel>
                              </>
                            )}
                          </Disclosure>
                        )
                      )}
                    </nav>
                  </div>
                </div>
              </Transition.Child>
              <div className="flex-shrink-0 w-14" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </Dialog>
          </Transition.Root>
          {/* Static sidebar for desktop */}
          <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 bg-white overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4">
                <a href="./dashboard">
                  <img className="h-8 w-auto" src={mainLogo} alt="Workflow" />
                </a>
              </div>
              <div className="mt-5 flex-grow flex flex-col">
                <nav
                  className="flex-1 px-2 space-y-1 bg-white"
                  aria-label="Sidebar"
                >
                  {navigation.map((item) =>
                    !item.children ? (
                      <div key={item.name}>
                        <a
                          href={item.href}
                          className={classNames(
                            item.current
                              ? "bg-gray-100 text-gray-900"
                              : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                            "group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md"
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </a>
                      </div>
                    ) : (
                      <Disclosure
                        as="div"
                        key={item.name}
                        className="space-y-1"
                      >
                        {({ open }) => (
                          <>
                            <Disclosure.Button
                              className={classNames(
                                item.current
                                  ? "bg-gray-100 text-gray-900"
                                  : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                              )}
                            >
                              <item.icon
                                className="mr-3 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                aria-hidden="true"
                              />
                              <span className="flex-1">{item.name}</span>
                              <svg
                                className={classNames(
                                  open
                                    ? "text-gray-400 rotate-90"
                                    : "text-gray-300",
                                  "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
                                )}
                                viewBox="0 0 20 20"
                                aria-hidden="true"
                              >
                                <path
                                  d="M6 6L14 10L6 14V6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </Disclosure.Button>
                            <Disclosure.Panel className="space-y-1">
                              {item.children.map((subItem) => (
                                <Disclosure.Button
                                  key={subItem.name}
                                  as="a"
                                  href={subItem.href}
                                  className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                                >
                                  {subItem.name}
                                </Disclosure.Button>
                              ))}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    )
                  )}
                </nav>
              </div>
            </div>
          </div>
          <div className="md:pl-64 flex flex-col flex-1">
            <div className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow">
              <button
                type="button"
                className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                onClick={() => this.open()}
              >
                <span className="sr-only">Open sidebar</span>
                <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
              </button>
              <div className="flex-1 px-4 flex justify-between">
                <div className="flex-1 flex">
                  <form className="w-full flex md:ml-0" action="#" method="GET">
                    <label htmlFor="search-field" className="sr-only">
                      Search
                    </label>
                    <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                      <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5" aria-hidden="true" />
                      </div>
                      <input
                        id="search-field"
                        className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
                        placeholder="Search"
                        type="search"
                        name="search"
                      />
                    </div>
                  </form>
                </div>
                <div className="ml-4 flex items-center md:ml-6">
                  <button
                    type="button"
                    className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <span className="sr-only">View notifications</span>
                    <BellIcon className="h-6 w-6" aria-hidden="true" />
                  </button>

                  {/* Profile dropdown */}
                  <Menu as="div" className="ml-3 relative">
                    <div>
                      <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span className="sr-only">Open user menu</span>
                        <img
                          className="h-8 w-8 rounded-full"
                          src={mainLogo}
                          alt=""
                        />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {userNavigation.map((item) => (
                          <Menu.Item key={item.name}>
                            {({ active }) => (
                              <Link
                                to={"#"}
                                onClick={this.logout}
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700"
                                )}
                              >
                                {item.name}
                              </Link>
                            )}
                          </Menu.Item>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
            </div>

            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    New Customer
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>

                  <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.saveCustomer}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="primary_contact_salutation_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Salutation
                                  </label>
                                  <select
                                    id="primary_contact_salutation_id"
                                    name="primary_contact_salutation_id"
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue={0}
                                  >
                                    <option value="0">------</option>
                                    {this.state.salutationsList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_salutation_id
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="first-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    First Name
                                  </label>
                                  <input
                                    type="text"
                                    name="primary_contact_first_name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    onChange={this.handleInput}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />

                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_first_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="last-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Last Name
                                  </label>
                                  <input
                                    type="text"
                                    name="primary_contact_last_name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    onChange={this.handleInput}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_last_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="first-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Company Name
                                  </label>
                                  <input
                                    type="text"
                                    name="company_name"
                                    id="company_name"
                                    onChange={this.handleInput}
                                    autoComplete="given-name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.company_name}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_display_name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Customer Display Name
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="customer_display_name"
                                    id="customer_display_name"
                                    onChange={this.handleInput}
                                    autoComplete="given-name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .customer_display_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_type_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Customer Type
                                    </span>
                                  </label>
                                  <select
                                    id="customer_type_id"
                                    name="customer_type_id"
                                    onChange={this.handleInput}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue={0}
                                  >
                                    <option value="">------</option>
                                    {this.state.cutomerTypelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_type_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="designation"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Designation
                                  </label>
                                  <input
                                    type="text"
                                    name="designation"
                                    id="designation"
                                    onChange={this.handleInput}
                                    autoComplete="designation"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.designation}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="designation"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Department
                                  </label>
                                  <input
                                    type="text"
                                    name="department"
                                    id="department"
                                    onChange={this.handleInput}
                                    autoComplete="department"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.department}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_mobile"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Customer Phone
                                  </label>
                                  <input
                                    type="number"
                                    name="customer_mobile"
                                    id="customer_mobile"
                                    onChange={this.handleInput}
                                    autoComplete="customer_mobile"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_mobile}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Customer Email
                                  </label>
                                  <input
                                    type="text"
                                    name="customer_email"
                                    id="customer_email"
                                    onChange={this.handleInput}
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_email}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="website"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Website
                                  </label>
                                  <input
                                    type="text"
                                    name="website"
                                    id="website"
                                    onChange={this.handleInput}
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.website}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      Tax Information
                                    </h3>
                                  </div>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="tax_preference_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Tax Preference
                                  </label>
                                  <select
                                    id="tax_preference_id"
                                    name="tax_preference_id"
                                    onChange={this.handleInput}
                                    autoComplete="taxPreference"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.taxprefercenceList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.tax_preference_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="currency_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Currency
                                  </label>
                                  <select
                                    id="currency_id"
                                    name="currency_id"
                                    onChange={this.handleInput}
                                    autoComplete="Currience"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="0">------</option>
                                    {this.state.currencyList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.currency_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="payment_term_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Payment Terms
                                  </label>
                                  <select
                                    id="payment_term_id"
                                    name="payment_term_id"
                                    onChange={this.handleInput}
                                    autoComplete="payment-Terms"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.paymentTerm.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.payment_term_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    GSTIN / UIN
                                  </label>
                                  <input
                                    type="text"
                                    name="gstin_uin"
                                    onChange={this.handleInput}
                                    id="gstin"
                                    autoComplete="street-address"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.gstin_uin}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="place_of_supply_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Place of Supply
                                  </label>
                                  <select
                                    id="place_of_supply_id"
                                    name="place_of_supply_id"
                                    onChange={this.handleInput}
                                    autoComplete="place_of_supply_id"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.placeofSupply.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="place_of_supply_id-error"
                                  >
                                    {this.state.error_list.place_of_supply_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      SHIPPING ADDRESS
                                    </h3>
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_attention"
                                    id="Attention"
                                    onChange={this.handleInput}
                                    autoComplete="street-address"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_attention}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="shipping_country_region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country / Region
                                  </label>
                                  <select
                                    id="shipping_country_region"
                                    name="shipping_country_region"
                                    onChange={this.handleInput}
                                    autoComplete="shipping_country_region"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.countriesList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="shipping_country_region-error"
                                    >
                                      {
                                        this.state.error_list
                                          .shipping_country_region
                                      }
                                    </p>
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 1
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_address_street_one"
                                    id="Street_address"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .shipping_address_street_one
                                    }
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 2
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_address_street_two"
                                    id="Street_address2"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .shipping_address_street_two
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_city"
                                    onChange={this.handleInput}
                                    id="city"
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_city}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State / Province
                                  </label>

                                  <select
                                    id="state"
                                    name="shipping_state"
                                    onChange={this.handleInput}
                                    autoComplete="shipping_state"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.shippingstatelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.shipping_state}
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="shipping_zip_code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Zip Code
                                  </label>
                                  <input
                                    type="number"
                                    name="shipping_zip_code"
                                    onChange={this.handleInput}
                                    id="shipping_zip_code"
                                    autoComplete="shipping_zip_code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_zip_code}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="shipping_phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Mobile
                                  </label>
                                  <input
                                    type="number"
                                    name="shipping_phone"
                                    id="shipping_phone"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_phone}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      BILLING ADDRESS
                                    </h3>
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_attention"
                                    id="Attention"
                                    onChange={this.handleInput}
                                    autoComplete="street-address"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_attention}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="billing_country_region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country / Region
                                  </label>
                                  <select
                                    id="billing_country_region"
                                    name="billing_country_region"
                                    onChange={this.handleInput}
                                    autoComplete="country-name"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.countriesList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .billing_country_region
                                    }
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 1
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_address_street_one"
                                    id="Street_address"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.Street_address}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 2
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_address_street_two"
                                    id="Street_address2"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.Street_address2}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_city"
                                    onChange={this.handleInput}
                                    id="city"
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_city}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="billing_state"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State / Province
                                  </label>

                                  <select
                                    id="state"
                                    name="billing_state"
                                    onChange={this.handleInput}
                                    autoComplete="billing_state"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.billingstatelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.billing_state}
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="postal-code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Zip Code
                                  </label>
                                  <input
                                    type="number"
                                    name="billing_zip_code"
                                    onChange={this.handleInput}
                                    id="postal-code"
                                    autoComplete="postal-code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_zip_code}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="billing_phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Mobile
                                  </label>
                                  <input
                                    type="number"
                                    name="billing_phone"
                                    id="billing_phone"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_phone}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="remark"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Remark
                                  </label>
                                  <input
                                    type="text"
                                    name="remark"
                                    id="remark"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.remark}
                                  </p>
                                </div>

                                {/*Contact person */}

                                {/*Contact person */}
                              </div>
                            </div>

                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-center  px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                      <Oval
                        height="30"
                        width="30"
                        radius="50"
                        color="green"
                        ariaLabel="three-dots-loading"
                        wrapperStyle
                        wrapperClass
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default Test1;
